import Rx4ax  from  '@shared/rx4axios';

export default class BaseService  {
    resource$ = Rx4ax;
}
